import axios from "axios";
import DevSwitch from '../../../DevSwitch'

export function requestGetGLAilmentFieldNew() {
  if (DevSwitch == true) {
    return axios.get('data/_dir/field/GLNew.json', { 'muteHttpExceptions': true })
  } else {
    return axios.get('https://www.dissidiacompendium.com/data/_dir/field/GLNew.json', { 'muteHttpExceptions': true })
  }
}
